/** Returns true if the SAN domain should have NO fee */
const isSanFeeExempt = (sanDomain: string, commonName: string) => {
	const normalize = (domain: string) =>
		domain.startsWith('www.') ? domain.slice(4) : domain;

	return normalize(sanDomain) === normalize(commonName);
};

export default isSanFeeExempt;
